import { render } from "./js-controlled-modal-parent.vue?vue&type=template&id=24b40970"
import script from "./js-controlled-modal-parent.vue?vue&type=script&lang=js"
export * from "./js-controlled-modal-parent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__